import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle, Key } from "react-feather";
import { useGetUsersQuery } from "../usersApi";
import DataTable from "../../../components/common/DataTable";
import CreateUserModal from "../components/CreateUserModal";
import ResetPasswordModal from "../components/ResetPasswordModal";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { paths } from "../../../routes/paths";

const UsersList = () => {
  const [search, setSearch] = useState("");
  const { selectedBranchId } = useBranchFilter();
  const { data: users = [], isLoading } = useGetUsersQuery({
    search: search || undefined,
    branchId: selectedBranchId ?? undefined,
  });
  const [showCreate, setShowCreate] = useState(false);
  const [resettingUserId, setResettingUserId] = useState(null);

  const columns = [
    {
      title: "Username",
      dataIndex: "username",
      render: (value, user) => (
        <Link to={paths.userDetail(user.userId)}>{value}</Link>
      ),
    },
    { title: "Full Name", dataIndex: "fullName" },
    { title: "Designation", dataIndex: "designationName", render: (v) => v || "-" },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (value) => (
        <span className={`badge ${value ? "badge-linesuccess" : "badge-linedanger"}`}>
          {value ? "Active" : "Disabled"}
        </span>
      ),
    },
    {
      title: "Must Change Password",
      dataIndex: "mustChangePassword",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, user) => (
        <div className="edit-delete-action">
          <Link to={paths.userDetail(user.userId)} className="btn btn-link me-2 p-2">
            View
          </Link>
          <button
            type="button"
            className="btn btn-link p-2"
            title="Reset password"
            onClick={() => setResettingUserId(user.userId)}
          >
            <Key size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Users</h4>
              <h6>Accounts scoped to your own branch(es)</h6>
            </div>
          </div>
          <div className="page-btn">
            <button
              type="button"
              className="btn btn-added"
              onClick={() => setShowCreate(true)}
            >
              <PlusCircle className="me-2" size={16} />
              Add New User
            </button>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search username or full name"
                    className="form-control form-control-sm formsearch"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable
                columns={columns}
                dataSource={users}
                rowKey="userId"
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>

      <CreateUserModal show={showCreate} onClose={() => setShowCreate(false)} />
      <ResetPasswordModal
        userId={resettingUserId}
        onClose={() => setResettingUserId(null)}
      />
    </div>
  );
};

export default UsersList;
